import { withStyles } from '@material-ui/core/styles';
import { default as TooltipMUI } from '@material-ui/core/Tooltip';

/**
 * Estilização do Tooltip
 */
const Tooltip = withStyles({
  tooltip: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '12px',
    lineHeight: '14px',
    textAlign: 'center',
    color: '#FFF',
    padding: '5px 8px',
    backgroundColor: '#858585',
  },
  // Comentado pois estava bugando os Tooltips, causando travamentos
  // tooltipPlacementTop: {
  //   margin: '0 0 11px 0',
  // },
  popper: {
    zIndex: 2500,
  },
})(TooltipMUI);

export default Tooltip;
